import styled from "styled-components";
import BoldText from "./BoldText";

export default styled(BoldText)`
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  line-height: 16px;
`;
